import { zodResolver } from '@hookform/resolvers/zod'
import { cn } from '@repo/tailwind-config/tailwind.functions'
import { useForm } from 'react-hook-form'
import { z, ZodType } from 'zod'

import { TravelCompanyType } from '../../../lib/types/enums/travel-company/travel-company-type'
import { TravelCompanyInput } from '../../../lib/types/models/travel-company/travel-company-input'
import { BaseFormProps } from '../../../lib/types/utils'
import { getSubmitAction } from '../../../lib/utils/buttons-config/validation-buttons-config'
import { getSelectedEnumOption } from '../../../lib/utils/functions/misc.functions'
import { createEnumSchema } from '../../../lib/utils/validations/enum-validation'
import { createStringSchema } from '../../../lib/utils/validations/string-validation'
import { FORM_MODE } from '../../../utils/constants/form.constants'
import { Form, FormControl, FormField, FormItem } from '../../elements/forms/form'
import ControlledInput from '../../elements/inputs/controlled-input'
import ControlledSelectInput from '../../elements/inputs/controlled-select-input'
import ValidationButtons from '../../elements/validation-buttons'

type Props = BaseFormProps<TravelCompanyInput> & {
  className?: string
}

const formSchema: ZodType<TravelCompanyInput> = z.object({
  name: createStringSchema('NOM'),
  modelType: createEnumSchema({
    enumType: TravelCompanyType,
    fieldName: 'modèle CSV'
  })
})

const TravelCompanyForm = ({ className, defaultValues, ...validationButtonProps }: Props) => {
  const form = useForm<TravelCompanyInput>({
    resolver: zodResolver(formSchema),
    defaultValues,
    mode: FORM_MODE
  })

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(getSubmitAction(validationButtonProps.buttonsConfig))}>
        <div className={cn('flex flex-col gap-4', className)}>
          <FormField
            control={form.control}
            name="name"
            render={({ field }) => (
              <FormItem className="flex-1">
                <FormControl>
                  <ControlledInput required type="text" label="NOM" {...field} />
                </FormControl>
              </FormItem>
            )}
          />

          <FormField
            control={form.control}
            name="modelType"
            render={({ field }) => (
              <FormItem className="flex-1">
                <FormControl>
                  <ControlledSelectInput
                    required
                    dropDownPosition="above"
                    label="Modèle CSV"
                    options={Object.values(TravelCompanyType).map((type) => ({
                      label: type,
                      value: type
                    }))}
                    selectedOption={getSelectedEnumOption(field.value, TravelCompanyType)}
                    {...field}
                  />
                </FormControl>
              </FormItem>
            )}
          />
        </div>

        <ValidationButtons {...validationButtonProps} hasBorderTop />
      </form>
    </Form>
  )
}

export default TravelCompanyForm
